export default __webpack_public_path__ + "static/media/christmas1.14e14951.png";